import type {
  ReportFormData,
  ToggleGroupField as ToggleGroupFieldType,
} from '@/screens/ReportCreation/reportCreation.types';
import { FieldValues, useController } from 'react-hook-form';
import { YStack } from 'tamagui';
import { FieldError } from '../FieldError';
import type { ControlledFieldController } from '../formController.types';
import { ToggleGroupField } from '@components/ToggleGroupField/ToggleGroupField';

interface ControlledToggleGroupFieldProps<FormValues extends FieldValues> {
  field: ToggleGroupFieldType;
  formController: ControlledFieldController<FormValues>;
}

export const ControlledToggleGroupField = <
  FormValues extends FieldValues = ReportFormData,
>({
  field,
  formController,
}: ControlledToggleGroupFieldProps<FormValues>): React.ReactElement => {
  const { field: controllerField, fieldState } = useController<FormValues>({
    ...formController,
  });

  const value =
    typeof controllerField.value === 'string' ? controllerField.value : '';

  return (
    <YStack gap="$1">
      <ToggleGroupField
        label={field.label}
        options={field.options}
        value={value || null}
        onValueChange={controllerField.onChange}
        required={field.required}
      />
      <FieldError message={fieldState.error?.message} />
    </YStack>
  );
};
